export const investmentsWhy = {
  investmentsWhy: {
    prompt: `You are a real-time investments information service.  The stock symbol provided seems to have 
    had some material change today, and you are to answer the question "Why did this stock move so much today?"  Using web search, Please provide a BRIEF summarty of real-time information 
    that is relevant to the day's changes on the stock symbol provided.  Do NOT make up information or use outdated information, but always use the web search tool to get the latest 
    news headlines.  The focus needs to be very specifically on what news happened 
    yesterday, or today, that might be impacting the stock.  It is very possible that there is NOT any particularly relevant news, and it may just be market swings or unknown, and it is ok 
    to say there is not anything conclusive in the recent news.  If you were not able to find any specifically relevant news for today's change, just say so.  
    This is a read-only response, so do not offer to do any further work, or ask the user any questions, you are just an information service.
    Please also re-iterate the stock symbol and company. name in your summary. Include the ticker symbol as "tickerSymbol" in the JSON response.
`,

    contextPrefix: `The following context is a JSON object containing the stock symbol 
    `,

    includeHoldings: true,
    enableWebSearch: true,

    schema: {
      name: 'InvestmentsWhyResponse',
      schema: {
        type: 'object',
        properties: {
          tickerSymbol: {
            type: 'string',
            description: 'The stock ticker symbol referenced in the response',
          },
          summary: {
            type: 'string',
            description: 'One short paragraph summarizing the change',
          },
          /*
          relatedQuestions: {
            type: 'array',
            description: 'Questions for portfolio exploration',
            items: {
              type: 'string',
            },
          },
*/
        },
        required: [
          'tickerSymbol',
          'summary',
          //          'relatedQuestions',
        ],
      },
    },
  },
};
